;(function($, undefined){

    var rnn, log,
    hasFileReader = !!window.FileReader,
    hasAjaxCapableSubmit = !!window.FormData;


    ///////////////////////////////////////////////////////////////
    //////////////                                   //////////////
    //////////////    This File Needs Refactoring    //////////////
    //////////////                                   //////////////
    ///////////////////////////////////////////////////////////////



    function initConfirmationLinks() {
        $('[data-confirm]').bind('click', function (event) {
            if (!confirm($(this).data('confirm'))) {
                event.preventDefault();
            }
        });
    }

    function initCharacterLimitMonitors() {
        $('.char-limit').each(function () {
            var $this, $counter, $control, limit;

            $this = $(this);
            $counter = $this.find('.char-limit-counter');
            $control = $this.find('input,textarea');

            function updateCounter() {
                var remaining = limit - $control.val().length;
                $counter.text(remaining);
                remaining === 1 ? $counter.addClass('singular') : $counter.removeClass('singular');
                remaining < 0 ? $counter.addClass('negative') : $counter.removeClass('negative');
            }

            if ($counter.length === 1 && $control.length === 1) {
                limit = ($counter.text() || $control.attr('maxlength'));
                limit && (limit = 0 + limit);
                if (limit) {
                    $control.bind("keyup change blur", updateCounter);
                    updateCounter();
                    $this.addClass('char-limit-enabled');
                }
            }
        });
    }

    function initWordLimitMonitors() {
        $('.word-limit').each(function () {
            var $this, $counter, $control, limit, words;

            $this = $(this);
            $counter = $this.find('.word-limit-counter');
            $control = $this.find('input,textarea');

            function updateCounter() {
                if ($control.val().match(/\S+/g)) {
                    words = $control.val().match(/\S+/g).length;
                } else {
                    words = 0;
                }
                var remaining = limit - words;

                $counter.text(remaining);
                remaining === 1 ? $counter.addClass('singular') : $counter.removeClass('singular');
                remaining < 0 ? $counter.addClass('negative') : $counter.removeClass('negative');
            }

            if ($counter.length === 1 && $control.length === 1) {
                limit = ($counter.text() || $control.attr('maxlength'));
                limit && (limit = 0 + limit);
                if (limit) {
                    $control.bind("keyup change blur", updateCounter);
                    updateCounter();
                    $this.addClass('word-limit-enabled');
                }
            }
        });
    }

    function initTypeAheadOnField(){
        /*
         * Required options:
         *  * url - The JSON URL data source
         *
         * Optional:
         *  * params - An object of extra GET parameters for URL.
         *  * input - A jQuery selector to specify the input element.
         *            Defaults to the current element.
         *  * target - A jQuery selector to place associated value.
         *
         */

        var $this = $(this),
            options = $this.data('typeahead-ajax'),
            $input = (options.input && $(options.input) || $this),
            $target = (options.target && $(options.target) || null),
            defaultParams = (options.params || {}),
            dataCache = {},
            resultCache = {},
            results = [],
            list_limit;

        if(!defaultParams.limit){
            list_limit = 8;
        }else{
            list_limit = defaultParams.limit
        }

        // Initialize the typeahead plugin.
        $input.typeahead({
            items: list_limit,
            minLength: 3,
            matcher: function(item) {
                /*
                 * Match each of the query words individually,
                 * so it doesn't need to be an exact phrase.
                 *
                 */
                var result = item.toLowerCase(),
                    tokens = this.query.toLowerCase().split(/\s+/),
                    match = true;
                $(tokens).each(function(index, token) {
                    if (token.length !== 0) {
                        if (result.indexOf(token) === -1) {
                            match = false;
                            return false;
                        }
                    }
                });
                return match;
            },
            source: function(query, process) {

                // Use cached results when possible.
                var cachedResults = resultCache[query];
                if (cachedResults !== undefined) {
                    return cachedResults;
                }

                // Build the GET parameters.
                var params = $.extend({
                    query: query,
                    limit: this.options.items
                }, defaultParams);

                // Trigger an async request which will pass the results
                // to the "process" callback function when ready.
                $.getJSON(options.url, params, function(data, textStatus, jqXHR) {

                    if ($target !== null) {
                        // Add this data to the cache, for setting the
                        // related value on the target field.
                        $.each(data, function(key, value) {
                            dataCache[key.toLowerCase()] = value;
                        });
                    }

                    // The results will be the object keys, which are the
                    // names of localities. Set this on the results variable
                    // so it can also be re-used as the previous results
                    // next time (see the end of the source function).
                    results = _.keys(data).sort();

                    if (params.intl) {
                        // When getting international results, prioritize
                        // results for the current site's country.
                        suffix = rnn.site.network.isNZ ? ', New Zealand' : ', Australia';
                        function endsWithSuffix(key) {
                            return key.indexOf(suffix, this.length - suffix.length) !== -1;
                        }
                        results = _.flatten([
                            [_.filter(results, endsWithSuffix)],
                            [_.reject(results, endsWithSuffix)]
                        ]);
                    }

                    // Cache the final results against the query,
                    // so we can avoid repeating this AJAX call.
                    resultCache[query] = results;

                    // Pass the results to the callback function so they
                    // can be rendered for the user. Use the current input
                    // value incase the user has changed it before this
                    // response came back.
                    process(resultCache[$input.val()] || []);
                });

                // Return the previous results immediately, while waiting
                // for the AJAX response to come back. This helps to avoid
                // some excessive flickering.
                return results;

            },
            show: function () {
                /*
                A copy of the bootstrap-typeahead.js function
                - Adding z-index modification
                */
                var pos = $.extend({}, this.$element.offset(), {
                    height: this.$element[0].offsetHeight
                }),
                    parentZIndex,
                    zIndex = this.$menu.css('z-index'),
                    $elementParent = this.$element.parent();

                //Traverse to find possible high z-indexs
                while ($elementParent) {
                    parentZIndex = $elementParent.css('z-index');
                    if (parentZIndex === "auto") {
                        if ($elementParent.is("body")) {
                            break; //You've hit the ceiling!! Get out!
                        }
                        $elementParent = $elementParent.parent();
                    } else {
                        zIndex = parseInt(parentZIndex, 10) + 1;
                        break;
                    }
                }

                // check to ensure this needs to appear over a modal.
                if($elementParent.hasClass('modal-dialog')){
                    zIndex = 9999;
                    this.$menu.css({
                        width: $elementParent.find('.controls .textInput').outerWidth(true)
                    });
                }

                this.$menu.css({
                  top: pos.top + pos.height,
                  left: pos.left,
                  'z-index': zIndex
                });

                this.$menu.show();
                this.shown = true;
                return this;
            }
        });

        // When the user changes the visible value, set the target field
        // with the related hidden value. This uses the cached results of
        // the typeahead ajax requests for matches.
        if (options.target) {
            $target = $(options.target);
            $input.change(function(){
                $target.val(dataCache[$input.val().toLowerCase()] || '');
            });
        }
    }

    function initTypeAhead() {
        $('[data-typeahead-ajax]').each(initTypeAheadOnField);
    }

    function initCleanUrl() {
        /*
        Cleans up the URL when submitting a GET form. It leaves out empty
        fields, sending the user to a more pretty destination URL.

        So, instead of sending the user to
            /photos/?keywords=dogs&type=&category=

        It would send them to
            /photos/?keywords=dogs

        */

        $(document).on('submit', 'form[method=get]:not(.disable-clean-url)', function(event) {
            var $form = $(this),
                baseUrl = $form.attr('action'),
                queryString = $form.find(':input').filter(function () {
                    return $.trim(this.value).length > 0
                }).serialize();

            if (queryString) {
                if (baseUrl.indexOf('?') === -1) {
                    window.location = baseUrl + '?' + queryString;
                } else {
                    window.location = baseUrl + '&' + queryString;
                }
            } else {
                window.location = baseUrl;
            }

            event.preventDefault();

        });
    }

    function createButtonGroup(options){
        var dropDown = $($.el.div({"class": "btn-group " + "dropdown-for-" + options.name},
                $.el.a({"class": "btn btn-large currentOption", "data-toggle": "dropdown" }),
                $.el.a({"class": "btn btn-large dropdown-toggle", "data-toggle": "dropdown"},
                    $.el.span({"class": "caret"})
                ),
                $.el.ul({"class": "dropdown-menu"})
            )),
            delegateInput = $($.el.input({
                type:'hidden',
                name: options.name,
                'class':options.name,
                'placeholder': options.placeholder,
                title: options.title
            })),
            controlGroup;

        dropDown.append(delegateInput);

        options.element = dropDown;
        controlGroup = createControlGroup(options);

        dropDown.on('click', '.dropdown-menu li', function(event){
            dropDown.children('.currentOption').text($(event.target).text());
            delegateInput.val($(event.target).data().value);
            dropDown.trigger('change');
        });
        delegateInput.on('change', function(event){
            dropDown.children('.currentOption').text(dropDown.children('ul').children('[data-value=' + $(event.target).val() + ']').text());
        });

        return controlGroup;
    }

    function isElement(obj) {
        try {
            //Using W3 DOM2 (works for FF, Opera and Chrom)
            return obj instanceof HTMLElement;
        }
        catch(e){
            //Browsers not supporting W3 DOM2 don't have HTMLElement and
            //an exception is thrown and we end up here. Testing some
            //properties that all elements have. (works on IE7)
            return obj &&
                obj.nodeType===1 &&
                typeof obj.style === "object" &&
                typeof obj.ownerDocument ==="object";
        }
    }

    function createControlGroup(options){
        var elementType = options.element || 'input',
            elementSubType = options.type || elementType === 'input' && 'text' || null,
            controlGroup = $($.el.div({'class':'control-group group-for-' + options.name})),
            label = $($.el.label({'for':options.name})).append(options.label),
            control;

        if(!options.element || typeof options.element === 'string'){
            control = $($.el[elementType]({
                type:elementSubType,
                name: options.name,
                'class':options.name,
                'placeholder': options.placeholder,
                title: options.title
            }));
        }else if(isElement($(options.element)[0])){
            control = options.element;
        }

        options.type === 'hidden' && controlGroup.hide();

        if(options.value){
            $(control).val(options.value);
        }

        if(elementSubType === 'checkbox'){
            return controlGroup.append(label.prepend(control), options.append)[0];
        }

        !options.label && label.hide();

        return controlGroup.append(label, control, options.append)[0];
    }

    function createErrorsAlert(target, errorFields){
        var form = $(target).closest('form'),
            errorMessages = $($.el.ul()),
            totalErrors = 0,
            alert;

        if(errorFields && !_.isString(errorFields)){
            for(var key in errorFields){
                var errorField = errorFields[key],
                    errorElement = $('[name="' + key + '"]', form);
                    fieldErrors = "";

                errorElement.closest('.control-group').addClass('error');

                errorField.fastEach(function(errorMessage){
                    fieldErrors += " " + errorMessage;

                    totalErrors++;

                    errorMessages.append($($.el.li({'data-errorfor': key}, errorElement.attr('title') + ": " + errorMessage)).on('click', function(){
                        $('[name="' + $(this).data('errorfor') + '"]', form).focus();
                    }));
                });
            }
        }

        if (_.isString(errorFields)){
            alert = rnn.modules.alert.show(form.children('.messages'),{
                type: 'error',
                heading: errorFields
            });
        } else {
            if(!totalErrors){
                alert = rnn.modules.alert.show(form.children('.messages'),{
                    type: 'error',
                    heading: "Unfortunately, an error occured. Please try again..."
                });
            }else{
                alert = rnn.modules.alert.show(form.children('.messages'),{
                    type: 'error',
                    heading: "Please correct the following and try submitting the form again...",
                    message: errorMessages
                });
            }
        }

        return alert;
    }

    function initAlertErrors() {
        /*
        Allow error message to be clicked and focus on the form field
        */
        $('[data-error-for]').each(function(){
            $(this).addClass('link').on('click', function(){
                $('[name="' + $(this).data().errorFor + '"]').focus();
            });
        });
    }

    function initLabelForPolyfill(){
        function labelForPolyfill(event){
            if(!$('#' + $(this).attr('for')).length){
                var target = $(this).closest('.control-group').find('[name=' + $(this).attr('for') + ']');
                if(target.is(':checkbox') && !$(event.target).is(':checkbox')){
                    target.is(':checked') && target.prop('checked',false) || target.prop('checked',true);
                }

                target.change().focus();
            }
        }
        $(document).on('click','[for]',labelForPolyfill);
    }

    function Field(options){
        for(var key in options){
            if(options.hasOwnProperty(key)){
                this[key] = options[key];
            }
        }
        this._errors = [];
        this._validationEvents = {};

        this.create(options);
    }

    Field.prototype = {
        constructor: Field,
        base: Field,
        create:function(options){

            var field = this;
            field.element = createControlGroup(options);

            // Add a validator that clears errors if there are none
            // Triggeres validation on change.
            field.addValidation('change keypress');

            field.element._model = field;

            field.addValidation('keyup change paste', function(field, eventName){
                if(field.maxChars != null && field.value().length > field.maxChars){
                    return 'This field can have a maximum of ' + field.maxChars + ' characters.';
                }
            });

            field.addValidation('submit', function(field, eventName){

                if (field.required) {
                    var $input = $(field.element).find(':input');
                    // If the input field is a checkbox then the value will be false
                    if ($input.is(':checkbox:not(:checked)') || field.value() === ''){
                        return 'This field cannot be empty';
                    }
                }
            });

            return field;
        },
        value: function(value){

            $input = $(this.element).find(':input');

            if (arguments.length) {
                $input.val(value);
                return this;
            } else {
                return $input.val();
            }
        },
        submit:function(form, next){
            next();

            return this;
        },
        success:function(form, next){
            next();

            return this;
        },
        error:function(form, next, error){
            // if no args, assume we are explicitly setting an error state
            // else, check to see if an error was explicitly passed.
            if(!arguments.length || error){
                $(this.element).addClass('error');
            }

            next && next();

            return this;
        },
        clearError:function(){
            $(this.element).removeClass('error');
        },

        // called after form submission complete.

        complete:function(form, next){
            next();

            return this;
        },
        clear:function(){
            $(this.element).find(':input').val(null);

            return this;
        },
        focus:function(){
            $(this.element).find(':input').focus();

            return this;
        },

        // provides an interface for any initialisation
        // required after the field is added to the dom.
        // default is a noop.

        init:function(form, next){
            next();

            return this;
        },

        // runs all validators and sets an error state
        // if any validator returns that there is an
        // error

        validate: function(triggeredEventName){
            var field = this,
                validationEvents = field._validationEvents;

            field._errors = [];

            for(var eventName in validationEvents){

                var eventValidators = validationEvents[eventName];

                if(Array.isArray(eventValidators)){
                    for(var i = 0; i < eventValidators.length; i++){
                        var error = eventValidators[i](field, triggeredEventName);
                        if(error){
                            field._errors.push(error);
                            break;
                        }
                    }
                }
                if(field._errors.length){
                    field.error();
                    break;
                }
            }

            if(!field._errors.length){
                field.clearError();
            }

            return field;
        },

        // pass a space seperated string of event names
        // and a callback to check field validity, if
        // the callback returns true, there are errors.

        addValidation: function(events, callback){
            var field = this,
                validationEvents = field._validationEvents,
                events = Array.isArray(events) && events || events.split(' ');

            for(var i = 0; i < events.length; i++){
                var eventName = events[i];

                if(eventName in validationEvents && callback){
                    validationEvents[eventName].push(callback);
                }else{
                    if(callback){
                        validationEvents[eventName] = [callback];
                    }
                    $(field.element).on(eventName, function(){
                        field.validate(eventName);
                    });
                }
            }
        },

        getErrors: function(){
            return this._errors;
        }
    };

    //  next field to call 'Middleware' generator
    function nextFieldGenerator(form, fn){
        var fieldNames = [],
            submitNextField,
            done = {
                done: function(){
                    if(fieldNames.length){
                        throw "All functions in the call chain must be called. Did you forget to call next() in a child?";
                    }
                }
            };

        for(var fieldName in form.fields){
            fieldNames.push(fieldName);
        }

        submitNextField = function(){
            if(fieldNames.length){
                fn(form.fields[fieldNames.shift()], submitNextField);
            }
            return done;
        };

        return submitNextField;
    }

    function Form(options){
        if(this.constructor === Form){
            throw "Attempted to instantiate an abstract object";
        }
        if(!options){
            options = {};
        }

        this.fields = {};

        for(var key in options){
            if(options.hasOwnProperty(key)){
                this[key] = options[key];
            }
        }

        this.create();
    }

    Form.prototype = {
        constructor: Form,
        base: Form,
        nextFieldGenerator: nextFieldGenerator,
        create: function(){
            var form = this,
                $formElement;

            this.element = $.el.form({
                    target: form.target,
                    action: form.action,
                    method: 'post',
                    enctype: 'multipart/form-data'
                },
                $.el.div({"class":"messages"})
            );

            $formElement = $(this.element);

            if (rnn.site.isMobile) {
                $formElement.addClass('contentWrapper'); //Helps target mobile display
            }

            if(this.submission && !this.submission.isDefault){
                this.element.appendChild($.el.div({"class":"contextInfo"},
                    $.el.span({"class":"submittingAgainst"}, "You are submitting against:"),
                    $.el.h3(form.submission.title),
                    $.el.p(form.submission.description)
                ));
                $formElement.addClass('hasContext');
            }

            $formElement.on('submit',function(event){
                event.preventDefault();
                form.submit();
            });
            this.element._model = this;
            return this;
        },
        init:function(form){
            var form = this,
                next = nextFieldGenerator(form, function(field, next){
                    field.init(form, next);
                });

            next().done();
        },
        destroy: function(){
            $(this.element).remove();
            return this;
        },
        reset: function(){
            this.destroy().create();

            return this;
        },
        validateReturn: function(data, success, error){
            data = $.parseJSON(data);
            if(!data){
                error({});
                return;
            }
            data.errors ? error(data) : success(data);
        },
        eachField: function(callback){
            for(var fieldName in this.fields){
                callback(this.fields[fieldName], fieldName, this);
            }
        },
        submit: function(){
            var form = this,
                errorData = {},
                next = nextFieldGenerator(form, function(field, next){
                    field.submit(form, next);
                });

            // check for errors on all form fields,
            // Then mark as done.
            form.eachField(function(field, name, form){
                field.validate();
                var fieldErrors = field.getErrors();

                if(fieldErrors.length){
                    if(!errorData.errors){
                        errorData.errors = {};
                    }
                    errorData.errors[name] = fieldErrors;
                }
            });

            if(errorData.errors){
                form.error(errorData);
                return form;
            }


            // Call .submit() on all form fields,
            // Then mark as done.
            next().done();

            // Some browsers need to submit file fields using the iFrame
            // approach. A field will set "submitWithIframe" when required.
            if (form.submitWithIframe || !(hasAjaxCapableSubmit)) {

                var formElement = $(form.element),
                    dateString = new Date().getTime().toString(),
                    randomString = Math.random().toString().slice(2),
                    frameId = ['form-submission-iframe', dateString, randomString].join('-'),
                    $submitFrame = $($.el.iframe({'id':frameId, 'name': frameId, src:"about:blank"}));

                $submitFrame.hide();

                $submitFrame.on('load',function(event){
                    var response;
                    var $this = $(this);

                    if(!$this.data('isloaded')){
                        $(this).data('isloaded', true);
                    }

                    response = this.contentWindow.document.body.innerText;

                    form.validateReturn(
                        response,
                        function(data){
                            form.success(data);
                        },
                        function(data){
                            form.error(data);
                        }
                    );

                    $submitFrame.remove();

                });

                formElement
                    .attr('target', frameId)
                    .append($submitFrame);

                form.element.submit();

                return form;

            } else {

                $.ajax({
                    url: form.action,
                    type: 'post',
                    xhr: function() {  // custom xhr
                        var xhrSubmission = $.ajaxSettings.xhr();
                        if(xhrSubmission.upload && typeof progressHandlingFunction === 'function'){
                            xhrSubmission.upload.addEventListener('progress',progressHandlingFunction, false);
                        }
                        return xhrSubmission;
                    },
                    success: function(data){
                        form.validateReturn(
                            data,
                            function(data){
                                form.success(data);
                            },
                            function(data){
                                form.error(data);
                            }
                        );
                        return form;
                    },
                    error: function(data){
                        form.error(data.responseText);
                    },
                    complete: function(data){
                        form.complete(data);
                    },
                    data: new FormData(form.element),
                    cache: false,
                    contentType: false,
                    processData: false
                });

                return form;
            }
        },
        success: function(){
            var form = this,
                next = nextFieldGenerator(form, function(field, next){
                    field.success(form, next).clear();
                });

            // Call .success() on all form fields.
            next().done();

            rnn.modules.notifications.success(form.successMessage);

            $(form.element).trigger('submitsuccess');
        },
        successMessage: "Your submission was successful",
        error: function(data){

            var form = this,
                formElement = $(form.element),
                errors = data && data.errors,
                totalErrors = 0,
                errorMessages = $($.el.ul()),
                next = nextFieldGenerator(form, function(field, next){
                    field.error(form, next, errors && errors[field.name]);
                });

            // Call .error() on all form fields.
            next().done();

            if(typeof data === 'string'){
                rnn.modules.alert.show(formElement.children('.messages'),{
                    type: 'error',
                    heading: "Unfortunately, an error occured. Please try again...",
                    message: data
                });
                return;
            }

            if(errors){
                for(var key in errors){
                    var error = errors[key],
                        fieldWithError = form.fields[key],
                        fieldErrors = "";

                    if(key === 'form'){
                        errorMessages.append(
                            $($.el.li(errors[key]))
                        );
                        totalErrors++;
                    }
                    if(!fieldWithError){
                        continue;
                    }

                    error.fastEach(function(errorMessage){
                        fieldErrors += " " + errorMessage;

                        totalErrors++;

                        errorMessages.append(
                            $($.el.li({'data-errorfor': key}, fieldWithError.title + ": " + errorMessage))
                            .data('field', fieldWithError)
                            .on('click', function(){
                                $(this).data('field').focus();
                            })
                        );
                    });
                }

                formElement.children('.messages').children().slideUp(function(){
                    $(this).empty();
                });

                if(!totalErrors){
                    rnn.modules.alert.show(formElement.children('.messages'),{
                        type: 'error',
                        heading: "Unfortunately, an error occured. Please try again..."
                    });
                }else{
                    rnn.modules.alert.show(formElement.children('.messages'),{
                        type: 'error',
                        heading: "Please correct the following and try submitting the form again...",
                        message: errorMessages
                    });
                }
            }
        },
        complete: function(){
            var form = this,
                next = nextFieldGenerator(form, function(field, next){
                    field.complete(form, next);
                });

            // Call .complete() on all form fields.
            next().done();
        },
        registerField: function(name, field, autoAppend){
            if(typeof field === 'boolean'){
                autoAppend = field;
            }

            if(typeof name === 'object'){
                field = name;
                name = field.name;
            }

            if(!(field instanceof Field)){
                field = new Field(field);
            }

            this.fields[name] = field;
            if(autoAppend){
                this.element.appendChild(field.element);
            }

            return field;

        },
        registerFieldGroup: function(groupOptions, fields, autoAppend) {
            // We need to implement this at some point because we currently don't support radio/checkboxes
            // that need the same field name.
        }
    };

    function onRecaptchaSolved(token) {
        // this recaptchaToken is hardcoded in the form field
        $("input[type=hidden]#recaptchaToken").val(token).closest('form').submit(); // stash the token in a hidden field and keep going
    }

    // Initialise Forms
    function initForms() {
        initConfirmationLinks();
        initCharacterLimitMonitors();
        initWordLimitMonitors();
        initCleanUrl();
        initTypeAhead();
        initAlertErrors();
        initLabelForPolyfill();
    }

    rnn = window.rnn;

    log = rnn.logging.log;

    rnn.modules.register('forms', {
        init: initForms,
        createErrorsAlert: createErrorsAlert,
        createControlGroup: createControlGroup,
        createButtonGroup: createButtonGroup,
        lazyTypeAhead: function(target){
            initTypeAheadOnField.call($(target)[0]);
        },
        Form: Form,
        Field: Field,
        onRecaptchaSolved: onRecaptchaSolved 
    });

})(jQuery);
